import { Section } from '../layout/Section'
import { leaders } from '../../data/leaders'
import { ImagePlaceholder } from '../ui/ImagePlaceholder'
import { Linkedin } from 'lucide-react'
import { trackExternalLink } from '../../lib/firebase'

export function Leaders() {
    return (
        <Section id="lideres" background="light">
            <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold text-dpxp-dark mb-4">
                    Nossos Líderes
                </h2>
                <p className="text-xl text-dpxp-muted max-w-2xl mx-auto">
                    Quem impulsiona a DPXP
                </p>
            </div>

            {/* Leaders Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {leaders.map((leader) => (
                    <div
                        key={leader.id}
                        className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
                    >
                        {/* Photo */}
                        <div className="relative aspect-square bg-gradient-to-br from-dpxp-primary/20 to-dpxp-secondary/20">
                            {leader.image ? (
                                <img
                                    src={leader.image}
                                    alt={leader.name}
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <ImagePlaceholder
                                    width={300}
                                    height={300}
                                    label={leader.name}
                                    className="w-full h-full"
                                />
                            )}

                            {/* LinkedIn Badge - canto inferior direito */}
                            <a
                                href={leader.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute bottom-3 right-3 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-[#0A66C2] hover:scale-110 transition-all duration-300"
                                aria-label={`LinkedIn de ${leader.name}`}
                                onClick={() => trackExternalLink('linkedin', leader.name, 'leaders')}
                            >
                                <Linkedin className="w-5 h-5" />
                            </a>
                        </div>

                        {/* Info */}
                        <div className="p-5">
                            <h3 className="font-bold text-dpxp-dark text-lg mb-1">
                                {leader.name}
                            </h3>
                            <p className="text-dpxp-accent text-sm font-medium mb-3">
                                {leader.role}
                            </p>
                            <p className="text-dpxp-muted text-sm leading-relaxed">
                                {leader.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Decorative element */}
            <div className="flex justify-center mt-12">
                <img
                    src="/assets/elementos-flutuantes-setas-decoracao-background-leve-alinhado-esquerda.svg"
                    alt=""
                    className="w-32 h-auto opacity-30"
                />
            </div>
        </Section>
    )
}
